module.exports = __webpack_public_path__ + "img/5.03.2d79a137.jpg";